import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { label: 'Strategy Consulting', to: '/services' },
      { label: 'Digital Transformation', to: '/services' },
      { label: 'Operations Excellence', to: '/services' },
      { label: 'M&A Advisory', to: '/services' },
    ],
    company: [
      { label: 'About Us', to: '/about' },
      { label: 'Case Studies', to: '/portfolio' },
      { label: 'Contact', to: '/contact' },
    ],
    resources: [
      { label: 'Blog', to: '/' },
      { label: 'Insights', to: '/' },
      { label: 'Careers', to: '/contact' },
    ],
  };

  return (
    <footer className="bg-dark-800 pt-16 pb-8">
      <div className="section-container">
        {/* Main Footer */}
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 pb-12 border-b border-white/5">
          {/* Brand */}
          <div className="col-span-2 md:col-span-4 lg:col-span-2">
            <Link to="/" className="inline-flex items-center gap-3 mb-4">
              <span className="w-10 h-10 flex items-center justify-center bg-primary rounded-xl font-serif text-xl font-bold text-white">
                P
              </span>
              <span className="font-sans text-xl font-bold text-white">Professional Consulting Groups</span>
            </Link>
            <p className="text-slate-400 text-sm max-w-xs mb-6">
              Transforming businesses through strategic insights and innovative solutions.
              Based in Moorhead, Minnesota, serving clients across the Midwest.
            </p>
            <div className="flex gap-3">
              {['LinkedIn', 'Twitter', 'Facebook'].map((social) => (
                <button
                  key={social}
                  className="w-9 h-9 bg-dark-700 rounded-full flex items-center justify-center text-slate-500 hover:text-primary hover:bg-dark-600 transition-colors"
                  aria-label={social}
                >
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                    {social === 'LinkedIn' && <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>}
                    {social === 'Twitter' && <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>}
                    {social === 'Facebook' && <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>}
                  </svg>
                </button>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold text-white mb-4 font-sans">Services</h4>
            <ul className="space-y-2">
              {footerLinks.services.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.to} className="text-sm text-slate-400 hover:text-primary transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4 font-sans">Company</h4>
            <ul className="space-y-2">
              {footerLinks.company.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.to} className="text-sm text-slate-400 hover:text-primary transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-white mb-4 font-sans">Resources</h4>
            <ul className="space-y-2">
              {footerLinks.resources.map((link, idx) => (
                <li key={idx}>
                  <Link to={link.to} className="text-sm text-slate-400 hover:text-primary transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>


        {/* Bottom */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">
            &copy; {currentYear} Professional Consulting Groups LLC. All rights reserved.
          </p>
          <div className="flex gap-6">
            <button className="text-sm text-slate-500 hover:text-slate-300 transition-colors">
              Privacy Policy
            </button>
            <button className="text-sm text-slate-500 hover:text-slate-300 transition-colors">
              Terms of Service
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
